import React, {useContext} from "react";
import {Redirect, Route} from "react-router";
import get from "lodash/get";
import AuthProvider from "./Auth/components/AuthProvider/AuthProvider";

const InboxRoutes = React.lazy(() =>
    import(/* webpackChunkName: "inbox" */ "./Inbox/InboxRoutes"),
);
const Settings = React.lazy(() =>
    import(/* webpackChunkName: "settings" */ "./Settings/components/Settings/Settings"),
);

/**
 * ProtectedRoutes render nothing while authState is loading,
 * and if the user is logged out it rederictes to the /auth route group.
 * Otherwise, it renders the routes that require authentication such as inbox,
 * chat and settings pages.
 */
export const ProtectedRoutesComponent = ({location}) => {
    const {isVerified} = useContext(AuthProvider.Context);

    if (!isVerified()) {
        return <Redirect to={{pathname: "/auth", state: {referrer: get(location, "pathname")}}} />;
    }

    return (
        <React.Fragment>
            <Route path="/settings" render={props => <Settings {...props} />} />
            <Route path="/inbox" render={props => <InboxRoutes {...props} />} />
        </React.Fragment>
    );
};

export default ProtectedRoutesComponent;
